import { useEffect, useState } from "react";
import { api, media, errText } from "../../lib/api";
import { ZoomImage } from "../../components/ZoomImage";
import { Switch } from "../../components/ui/switch";
import { eurOf, useEurRate } from "../admin/ui";

export default function ReadOnlyCatalogue() {
  const [rows, setRows] = useState(null);
  const [query, setQuery] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState({});
  const fx = useEurRate();
  useEffect(() => {
    api.get("/florist/products").then(({ data }) => setRows(data.products)).catch(e => setError(errText(e)));
  }, []);
  const toggle = async (p, enabled) => {
    setBusy(b => ({ ...b, [p.id]: true })); setError("");
    try {
      await api.put(`/florist/products/${p.id}/activation`, { enabled });
      setRows(r => r.map(x => x.id === p.id ? { ...x, enabled } : x));
    } catch (e) { setError(errText(e)); }
    finally { setBusy(b => ({ ...b, [p.id]: false })); }
  };
  return <div className="space-y-4" data-testid="florist-readonly-catalogue">
    <div className="flex flex-wrap gap-3 justify-between items-center">
      <h2 className="font-display text-lg" data-testid="partner-catalogue-heading">Catalogue Fleurinelle</h2>
      <span className="text-sm text-muted" data-testid="partner-active-count">{(rows || []).filter(p => p.enabled).length} bouquets activés</span>
    </div>
    <input className="field" aria-label="Rechercher un bouquet" placeholder="Rechercher un bouquet…" value={query} onChange={e => setQuery(e.target.value)} data-testid="partner-catalogue-search" />
    {error && <p role="alert" className="text-danger text-sm" data-testid="partner-catalogue-error">{error}</p>}
    {!rows && !error && <p data-testid="partner-catalogue-loading">Chargement…</p>}
    {rows?.length === 0 && <p data-testid="florist-readonly-empty">Aucun bouquet pour le moment.</p>}
    {(rows || []).filter(p => p.title.toLowerCase().includes(query.toLowerCase())).map(p => <article key={p.id} className="card p-4 flex flex-wrap items-start gap-4" data-testid={`florist-readonly-product-${p.id}`}>
      {p.images[0] && <ZoomImage src={media(p.images[0])} alt={p.title} caption={p.title} className="w-20 aspect-[4/5] shrink-0" testid={`florist-readonly-photo-${p.id}`} />}
      <div className="flex-1 min-w-[140px]">
        <h3 className="text-sm text-ink" data-testid={`partner-bouquet-title-${p.id}`}>{p.title}</h3>
        <p className="text-xs text-muted mt-1" data-testid={`partner-bouquet-description-${p.id}`}>{p.description}</p>
        <div className="mt-2 space-y-1">{p.size_variants.map((v, i) => <p key={v.name} className="text-xs tabular" data-testid={`partner-bouquet-cost-${p.id}-${i}`}>{v.name} · {v.cost_price_mad} MAD <span className="text-muted">{eurOf(fx, v.cost_price_mad)}</span></p>)}</div>
      </div>
      <label className="flex items-center gap-2 text-xs shrink-0">
        <Switch checked={p.enabled} disabled={busy[p.id]} onCheckedChange={enabled => toggle(p, enabled)} aria-label={`Livraison ${p.title}`} data-testid={`partner-bouquet-toggle-${p.id}`} />
        <span data-testid={`partner-bouquet-status-${p.id}`}>{p.enabled ? "Activé" : "Désactivé"}</span>
      </label>
    </article>)}
  </div>;
}